<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <show-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import ShowForm from "./Form"
import model from "./model"

export default {
  components: { ShowForm },
  data() {
    return { model }
  },
}
</script>
